<div class="order-details-div">
  <span class="qb-heading-reward-data">Select {{ type }}</span>
  <div class="order-details-info mat-select-report-filter">
    <mat-select
      [placeholder]="'Select ' + type"
      (closed)="resetFilter()"
      [multiple]="isMultiple"
      [(ngModel)]="selectedData"
      (ngModelChange)="onSelectionChange()"
    >
      <div class="qb-rectangle">
        <div class="qb-rect">
          <mat-icon class="qb-icon" matPrefix>search</mat-icon>
          <input
            class="qb-no-border-input"
            type="text"
            [(ngModel)]="filter.label"
            (keydown)="$event.stopPropagation()"
            (input)="$event.stopPropagation()"
            placeholder=" Search by name "
          />
        </div>
      </div>
      <mat-option
        *ngFor="let val of dataList | labelPipe : filter.label : 'name'"
        [value]="isMultiple ? val : val.id"
        (onSelectionChange)="onDataChange($event)"
        [matTooltip]="val.name"
      >
        {{ val.name }}
      </mat-option>
      <mat-option
        *ngIf="(dataList | labelPipe : filter.label : 'name')?.length === 0"
        [disabled]="true"
      >
        No data available
      </mat-option>
    </mat-select>
  </div>
</div>
